@if (!hideUI) {
  <span>
    @if (!hideText) {
      <button mat-button id="theme-selector" [mat-menu-trigger-for]="themeMenu" matTooltip="Select a theme!" tabindex="-1">
        <mat-icon class="auto-flip">format_color_fill</mat-icon>
        <span> theme</span>
      </button>
    }
    @if (hideText) {
      <button mat-icon-button id="theme-selector" [mat-menu-trigger-for]="themeMenu" matTooltip="Select a theme!" tabindex="-1">
        <mat-icon class="auto-flip">format_color_fill</mat-icon>
      </button>
    }
    <mat-menu #themeMenu="matMenu" class="theme-menu">
      <mat-radio-group (change)="onThemeChanged($event)" aria-label="Select an option" class="theme-group">
        <mat-radio-button value="0" [checked]="theme == 0">{{'general.dark' | transloco}}</mat-radio-button>
        <mat-radio-button value="1" [checked]="theme == 1">{{'general.light' | transloco}}</mat-radio-button>
        <mat-radio-button value="2" [checked]="theme == 2">{{'ai.gradient' | transloco}}</mat-radio-button>
      </mat-radio-group>
      <!-- <mat-grid-list cols="2" class="theme-selectors-container">
      <mat-grid-tile>
        <button mat-button class="theme-selector"
          (click)="$event.stopPropagation(); setActiveTheme(theme)">
          <div class="indigo-pink theme-primary center">
            <div class="indigo-pink theme-accent"></div>
            <div class="indigo-pink theme-warn"></div>
            <mat-icon *ngIf="activeTheme===theme" class="center theme-check">check</mat-icon>
          </div>
        </button>
      </mat-grid-tile>
      <mat-grid-tile>
        <button mat-button class="theme-selector"
          (click)="$event.stopPropagation(); setActiveTheme(theme)">
          <div class="indigo-pink theme-primary center">
            <div class="indigo-pink theme-accent"></div>
            <div class="indigo-pink theme-warn"></div>
            <mat-icon *ngIf="activeTheme===theme" class="center theme-check">check</mat-icon>
          </div>
        </button>
      </mat-grid-tile>
    </mat-grid-list> -->
  </mat-menu>
</span>
}
